import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

export default memo(OrgBilling);

const accountOptions = ['Dealer', 'OEM', 'Operator', 'Partner'].map(
  (value) => ({ label: value, value })
);

const termsOptions = ['Pilot', '1 Year', '2 Year', '3 Year'].map((value) => ({
  label: value,
  value,
}));

function OrgBilling(props) {
  return (
    <div className="row">
      <div className="col-12 form-group">
        <label htmlFor="account_id" className="modal-inputlabel-text">
          Custom Organization or Account ID
        </label>
        <input
          className="form-control form-control-sm modal-placeholder-text"
          name="account_id"
          onChange={props.handlePropUpdate}
          type="text"
          value={props.org?.account_id}
        />
      </div>
      <div className="col-12 form-group">
        <label htmlFor="subscription_terms" className="modal-inputlabel-text">
          Subscription Type
        </label>
        <Select
          classNamePrefix="select-control"
          isSearchable
          maxMenuHeight={125}
          name="subscription_terms"
          onChange={(selected) =>
            props.handlePropUpdate({
              target: {
                name: 'subscription_terms',
                value: selected?.value ?? '',
              },
            })
          }
          options={termsOptions}
          placeholder="Select a Subscription Type"
          value={termsOptions.find(
            ({ value }) => value === props.org?.subscription_terms
          )}
        />
      </div>
      <div className="col-12 form-group">
        <label htmlFor="account_type" className="modal-inputlabel-text">
          Organization Type
        </label>
        <Select
          classNamePrefix="select-control"
          isSearchable
          maxMenuHeight={125}
          name="account_type"
          onChange={(selected) =>
            props.handlePropUpdate({
              target: {
                name: 'account_type',
                value: selected?.value ?? '',
              },
            })
          }
          options={accountOptions}
          placeholder="Select an Organization Type"
          value={accountOptions.find(
            ({ value }) => value === props.org?.account_type
          )}
        />
      </div>
    </div>
  );
}

OrgBilling.propTypes = {
  handlePropUpdate: PropTypes.func,
  org: PropTypes.object,
};
